const FileBtn = ({pick, text}) => {
	return (
		<div onClick={pick} className='fileBtn'>{text}</div>
	)
}

export default FileBtn